export default __webpack_public_path__ + "static/media/eye-hide.8985717f.svg";